import type { ProLayoutProps } from '@ant-design/pro-components';

/**
 * @name
 */
const Settings: ProLayoutProps & {
  pwa?: boolean;
  logo?: string;
} = {
  navTheme: 'light',
  // Green
  colorPrimary: '#00796b',
  layout: 'top',
  contentWidth: 'Fluid',
  fixedHeader: false,
  fixSiderbar: true,
  colorWeak: false,
  title: 'Fast Response',
  pwa: true,
  iconfontUrl: '',
  token: {
    header: {
      colorHeaderTitle: '#ffffff',
      colorBgHeader: '#00796b',
      // colorBgMenuItemHover: '#00695c',
      // colorTextMenu: '#ffffff',
      // colorTextMenuActive: '#f2f2f2',
      colorBgMenuItemSelected: '#00695c',
      colorTextRightActionsItem: '#ffffff',
      colorTextMenuSelected: '#ffffff',

      /*
      colorBgMenuElevated: 'black',
      colorTextMenuSecondary: 'red',
      colorBgRightActionsItemHover: '#00695c',
      colorBgScrollHeader: '#00796b', */
    },

    sider: {
      colorTextMenuTitle: 'white',
      /*colorBgCollapsedButton:
      colorTextCollapsedButtonHover:
      colorTextCollapsedButton:
      colorMenuBackground:
      menuHeight: number;
      colorBgMenuItemCollapsedElevated:
      colorMenuItemDivider:
      colorBgMenuItemHover:
      colorBgMenuItemActive:
      colorBgMenuItemSelected:
      colorTextMenuSelected:
      colorTextMenuItemHover:
      colorTextMenuActive:
      colorTextMenu:
      colorTextMenuSecondary:
      paddingInlineLayoutMenu: number;
      paddingBlockLayoutMenu: number;
      colorTextMenuTitle: string;
      colorTextSubMenuSelected: string;*/
    },


    pageContainer: {
      paddingBlockPageContainerContent: 8,
      paddingInlinePageContainerContent: 16,
    },
  },
};

export default Settings;
